import * as ActionType from "./admin.type";
import { setToast } from "../../../util/toast";
import { apiClient } from "../../../api/client";

const normalizeError = (error) => ({
  message: error?.message || "Request failed",
  code: error?.code || "UNKNOWN",
  details: error?.details || {},
});

export const signupAdmin = (signup) => async (dispatch) => {
  const res = await apiClient.post("admin/create", signup);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.SIGNUP_ADMIN });
    setToast("success", "Signup Successfully!");
    setTimeout(() => {
      window.location.href = "/admin-login";
    }, 3000);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateCode = (signup) => async () => {
  const res = await apiClient.patch("admin/updateCode", signup);
  if (res.ok && res.data?.status) {
    setToast("success", "Purchase Code Update Successfully !");
    setTimeout(() => {
      window.location.href = "/";
    }, 3000);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const loginAdmin = (token) => (dispatch) => {
  if (token) {
    dispatch({ type: ActionType.LOGIN_ADMIN, payload: token });
  }
};

// get profile
export const getProfile = () => async (dispatch) => {
  dispatch({ type: ActionType.PROFILE_ADMIN_REQUEST });
  const res = await apiClient.get("/v1/auth/me");
  if (res.ok && res.data?.ok) {
    dispatch({ type: ActionType.PROFILE_ADMIN_SUCCESS });
    dispatch({
      type: ActionType.PROFILE_ADMIN,
      payload: res.data?.data?.user,
    });
  } else {
    dispatch({
      type: ActionType.PROFILE_ADMIN_FAILURE,
      payload: normalizeError(res.data?.error || res),
    });
  }
};

// Update Admin profile image
export const UpdateAdminImage = (formData) => async (dispatch) => {
  const res = await apiClient.patch("admin/updateImage", formData);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_IMAGE_PROFILE,
      payload: res.data.admin,
    });
    setToast("success", "Image Update Successfully");
  } else if (!res.ok) {
    setToast("error", res.message);
  }
};

export const updateProfile = (profileData) => async (dispatch) => {
  const res = await apiClient.patch("admin/updateProfile", profileData);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_PROFILE, payload: res.data.admin });
    setToast("success", "Profile Update Successfully");
  } else if (res.ok) {
    setToast("error", res.data?.message || "Unable to update profile");
  } else {
    setToast("error", res.message);
  }
};

export const ChangeAdminPassword = (password) => async (dispatch) => {
  const res = await apiClient.patch("admin/updatePassword", password);
  if (res.ok && res.data?.status) {
    setToast("success", "Your Password Changed Successfully !");
    dispatch({ type: ActionType.LOGOUT_ADMIN });
    setTimeout(() => {
      window.location.href = "/";
    }, [3000]);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const forgotPassword = (data) => async () => {
  const res = await apiClient.post("admin/forgotPassword", data);
  if (res.ok && res.data?.status === true) {
    setToast("success", "Email Send Successfully !");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const resetPassword = (adminId, data) => async (dispatch) => {
  const res = await apiClient.post(`admin/setPassword?adminId=${adminId}`, data);
  if (res.ok && res.data?.status === true) {
    setToast("success", "Password Changed Successfully !");
    setTimeout(() => {
      dispatch({ type: ActionType.LOGOUT_ADMIN });
      window.location.href = "/";
    }, [100]);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
